import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Prismic, { getDocumentByUid, getDocumentsByType } from 'helpers/Prismic';
import { globalPropsRequests } from 'utils/globalProps';
import Modal from 'components/ContactUsModal';
import { Link } from 'react-scroll';
import { RichText } from 'prismic-reactjs';
import { API } from 'lib/arkade-graphql';
import breakPoints from 'helpers/Styles';
import ProductCards from 'containers/ProductCards';
import Head from 'next/head';
import Script from 'next/script';

function ServerLandingPage({ content, pcModels, featureListDOCS, modelsData }) {
  const { isFallback } = useRouter();
  const pcModelsPrismic = content.pc_models;
  const bannerData = content?.body[0];
  const features = content.body1[0].items;
  const benefitsTitles = content.body2[0].primary;
  const benefits = content.body2[1].items;
  const partners = content.body2[3].items;
  const contact = content.body[1].primary;
  const twoColumns = content.body2[2].primary;

  const tabs = ['Introduction', 'Models', 'Benefits', 'Specification'];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [showModal, setShowModal] = useState(false);
  const [hasFeature, setHasFeature] = useState(false);
  const [activeFeature, setActiveFeature] = useState(null);
  const [activeGroup, setActiveGroup] = useState(
    content.servers_groups[0].servers_group,
  );
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setIsOpen(false);
  };

  const {
    og_description: ogDescription,
    og_image: ogImage,
    seo_title: seoTitle,
    seo_description: seoDescription,
  } = content;

  const filteredPcModels = pcModelsPrismic.filter(
    (updatedPcModel) => updatedPcModel.servers_group === activeGroup,
  );

  const newFilteredPcModels = filteredPcModels.map((pcModel, index) => {
    pcModel.featureDoc = featureListDOCS.find(
      (feature) => feature.id === pcModel.features.id,
    );
    return pcModel;
  });

  // console.log('newFilteredPcModels', newFilteredPcModels);

  const specifications = content?.body3.find(
    (body) => body.primary.servers_group === activeGroup,
  );

  const handleActiveNav = (tab) => {
    setActiveTab(tab);
  };

  const featureHandleClick = (item) => {
    setHasFeature(true);
    setActiveFeature(item);
  };

  const removeFeatureClick = () => {
    setHasFeature(false);
    setActiveFeature(null);
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const setActiveDesktop = (e) => {
    const selectedTab = e?.target?.value;
    handleActiveNav(selectedTab);
  };

  if (isFallback) {
    return <Loader />;
  }

  if (!content) {
    return <Error code={404} />;
  }

  return content ? (
    <>
      <Head>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:description" content={ogDescription} />
        <meta
          property="og:image"
          content={
            ogImage?.url
              ? ogImage?.url
              : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ogImage.png?v=1713964496'
          }
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1024" />
        <meta property="og:image:height" content="1024" />
      </Head>
      <Script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GTM_ID}');`,
        }}
        strategy="lazyOnload"
      />
      <div className="main-container-server-landing-page">
        <div className="banner">
          <div className="banner-wrapper">
            <div className="banner_title">
              {bannerData.primary.banner_title}
            </div>
            <div className="banner_subtitle">
              {bannerData.primary.banner_description}
            </div>
          </div>
        </div>
        <div className="tab_container">
          <div className="tab-wrapper">
            <div className="tabs">
              {tabs.map((tab) => {
                const setActiveDesktop = () => {
                  handleActiveNav(`${tab}`);
                };
                return (
                  <Link
                    onSetActive={setActiveDesktop}
                    to={tab}
                    spy
                    smooth
                    offset={-50}
                    duration={1000}
                    delay={0}
                  >
                    <div
                      key={tab}
                      className={`tab ${activeTab === tab ? 'active' : ''}`}
                    >
                      {tab}
                    </div>
                  </Link>
                );
              })}
            </div>
            <div className="tabs-mobile">
              <div className="select-tabs" onClick={() => setIsOpen(!isOpen)}>
                {activeTab}
                <span className={`arrow ${isOpen ? 'up' : 'down'}`} />
              </div>
              <div className={`options ${isOpen ? 'show' : ''}`}>
                {tabs.map((tab, index) => {
                  const setActiveDesktop = () => {
                    handleActiveNav(`${tab}`);
                  };
                  return (
                    <Link
                      key={index}
                      onSetActive={setActiveDesktop}
                      to={tab}
                      spy
                      smooth
                      offset={-50}
                      duration={1000}
                      delay={0}
                    >
                      <div
                        className={`option-tab ${
                          activeTab === tab ? 'active' : ''
                        }`}
                        onClick={() => handleTabClick(tab)}
                      >
                        {tab}
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
            <div className="contact-us-tab" onClick={handleOpenModal}>
              Contact Us
            </div>
          </div>
          <Modal show={showModal} onClose={handleCloseModal} />
        </div>
        <div className="intro" id="Introduction">
          <div className="intro-wrapper">
            <div className="intro_description">
              {RichText.render(content.intro_description)}
            </div>
          </div>
        </div>
        <div
          className="introduction"
          style={{
            backgroundImage: `url(${content.background_image.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="features">
            <div className="features_title">Why Aftershock?</div>
            {hasFeature ? (
              <div
                className="active_feature"
                style={{
                  backgroundImage: `url(${activeFeature.feature_image.url})`,
                  backgroundPosition:
                    window.innerWidth < 991 ? 'bottom center' : 'right center',
                  backgroundSize:
                    window.innerWidth < 991 ? 'contain' : 'auto 100%',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                <button
                  className="closeButton"
                  onClick={() => removeFeatureClick()}
                >
                  ×
                </button>
                <div className="active_feature_title">
                  {activeFeature.feature_title}
                </div>
                <div className="active_feature_description">
                  {RichText.render(activeFeature.feature_description)}
                </div>
              </div>
            ) : (
              <div className="features_container">
                {features?.map((feature, index) => (
                  <div
                    key={index}
                    className="feature"
                    style={{
                      backgroundImage: `url(${feature.feature_image.url})`,
                    }}
                    onClick={() => featureHandleClick(feature)}
                  >
                    <div className="feature_title1">
                      {feature.feature_title}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="models-container" id="Models">
          <div className="models-title">{content.models_title[0].text}</div>
          <div className="servers_groups_wrapper">
            {content.servers_groups.map((servers_group, index) => (
              <div
                key={index}
                className={`servers_group ${
                  activeGroup === servers_group.servers_group
                    ? 'active_group'
                    : ''
                }`}
                onClick={() => setActiveGroup(servers_group.servers_group)}
              >
                {servers_group.servers_group}
              </div>
            ))}
          </div>
          <div className="servers_groups_mobile">
            <div
              className="select-servers_group"
              onClick={() => setIsOpen1(!isOpen1)}
            >
              {activeGroup}
              <span className={`arrow ${isOpen1 ? 'up' : 'down'}`} />
            </div>
            <div className={`servers_groups ${isOpen1 ? 'show' : ''}`}>
              {content.servers_groups.map((servers_group, index) => {
                return (
                  <div
                    key={index}
                    className={'group_options'}
                    onClick={() => {
                      setActiveGroup(servers_group.servers_group);
                      setIsOpen1(!isOpen1);
                    }}
                  >
                    {servers_group.servers_group}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="product-list">
            <ProductCards
              products={newFilteredPcModels}
              features={featureListDOCS}
              fixedPrice={true}
              readyToShip={false}
              pcModels={pcModels}
            />
          </div>
        </div>
        <div
          className="benefits"
          id="Benefits"
          style={{
            backgroundImage: `url(${content.background_image1.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="benefits-wrapper">
            <div className="features_title">{benefitsTitles.title1}</div>
            <div className="intro_description">
              {benefitsTitles.description}
            </div>
            <div className="benefits_options">
              {benefits.map((benefit, index) => (
                <div className="benefit" key={index}>
                  <img className="benefit_image" src={benefit.image.url} />
                  <div className="benefit_title">{benefit.image_title}</div>
                  <div className="benefit_subtitle">
                    {benefit.image_subtitle}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="two-column-section">
          <div className="two-column-wrapper">
            <div className="two-column-titles">
              <div className="two-column-title">
                {twoColumns.column_link_title}
              </div>
              <div className="two-column-subtitle">
                {twoColumns.column_content[0].text}
              </div>
            </div>
            <img className="two-column-image" src={twoColumns.image.url} />
          </div>
        </div>
        <div
          className="sub-section"
          style={{
            backgroundImage: `url(${content.body2[3].primary.background_partners.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="partners">
            <div className="partners_title">
              {content.body2[3].primary.partners_title}
            </div>
            <div className="partners_subtitle">
              {content.body2[3].primary.partners_subtitle}
            </div>
            <div className="partners-images-wrapper">
              <div className="partners-images-container">
                {partners.map((partner, index) => (
                  <img
                    className="partner-image"
                    key={index}
                    src={partner.partner_image.url}
                    alt="partner"
                  />
                ))}
                {partners.map((partner, index) => (
                  <img
                    className="partner-image"
                    key={`${index}-clone`}
                    src={partner.partner_image.url}
                    alt="partner"
                  />
                ))}
                {partners.map((partner, index) => (
                  <img
                    className="partner-image"
                    key={`${index}-clone`}
                    src={partner.partner_image.url}
                    alt="partner"
                  />
                ))}
                {partners.map((partner, index) => (
                  <img
                    className="partner-image"
                    key={`${index}-clone`}
                    src={partner.partner_image.url}
                    alt="partner"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="specification-container" id="Specification">
          <div className="specification-title">Specifications</div>
          <div className="servers_groups_wrapper">
            {content.servers_groups.map((servers_group, index) => (
              <div
                key={index}
                className={`servers_group ${
                  activeGroup === servers_group.servers_group
                    ? 'active_group'
                    : ''
                }`}
                onClick={() => setActiveGroup(servers_group.servers_group)}
              >
                {servers_group.servers_group}
              </div>
            ))}
          </div>
          <div className="servers_groups_mobile">
            <div
              className="select-servers_group"
              onClick={() => setIsOpen2(!isOpen2)}
            >
              {activeGroup}
              <span className={`arrow ${isOpen2 ? 'up' : 'down'}`} />
            </div>
            <div className={`servers_groups ${isOpen2 ? 'show' : ''}`}>
              {content.servers_groups.map((servers_group, index) => {
                return (
                  <div
                    key={index}
                    className={'group_options'}
                    onClick={() => {
                      setActiveGroup(servers_group.servers_group);
                      setIsOpen2(!isOpen2);
                    }}
                  >
                    {servers_group.servers_group}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="specification">
            {specifications.items.map((specification, index) => (
              <div className="specification-row" key={index}>
                <div className="specification-name">
                  {specification.table_name}
                </div>
                <div className="specification-value">
                  {specification.table_value}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className="contact-us-section"
          style={{
            backgroundImage: `url(${contact.background_contacts.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="contact-wrapper">
            <div className="contact-title">{contact.contact_title}</div>
            <div className="contact-subtitle">
              {contact.contact_description}
            </div>
            <div className="contact-button" onClick={handleOpenModal}>
              {contact.contact_button_text}
            </div>
          </div>
        </div>
      </div>

      <style jsx global>
        {`
          @font-face {
            font-family: 'EurostileExtended';
            src: url('/fonts/EuroStyleNormal.woff') format('woff');
            font-weight: normal;
            font-style: normal;
          }
          .banner {
            height: 547px;
            display: flex;
            justify-content: center;
          }
          .banner-wrapper {
            background-image: url(${bannerData.primary.banner_image.url});
            background-size: contain;
            background-position: right;
            background-repeat: no-repeat;
            max-width: 1440px;
            width: 100%;
            height: 100%;
          }
          .banner::before {
            content: '';
            position: absolute;
            border-radius: 4px;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              to right,
              rgba(0, 0, 0, 1) 0%,
              rgba(0, 0, 0, 0.9) 40%,
              rgba(0, 0, 0, 0.1) 70%,
              rgba(0, 0, 0, 0) 100%
            );
            z-index: 0;
            pointer-events: none;
          }
          .banner_title {
            padding-top: 107px;
            padding-left: 30px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 64px;
            position: relative;
            z-index: 2;
          }
          .banner_subtitle {
            font-family: 'EurostileExtended';
            color: #b4b4b4;
            letter-spacing: 1px;
            padding-left: 30px;
            font-size: 40px;
            position: relative;
            z-index: 2;
          }
          .tab_container {
            background-color: #1f1f1f;
            top: 65px;
            height: 75px;
            position: sticky;
            z-index: 3;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .tab-wrapper {
            max-width: 1440px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .tabs {
            display: flex;
            gap: 33px;
            padding-left: 30px;
          }
          .tab {
            box-sizing: border-box;
            height: 75px;
            display: flex;
            align-items: center;
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-size: 24px;
            cursor: pointer;
            position: relative;
          }
          .tab.active::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 5px;
            background-color: #a41c1c;
          }
          .tabs-mobile {
            display: none;
            width: 180px;
            margin-left: 15px;
            position: relative;
          }
          .servers_groups_mobile {
            display: none;
            width: 180px;
            margin-left: 15px;
            position: relative;
          }
          .select-tabs {
            width: 100%;
            height: 40px;
            background-color: #333;
            color: #fff;
            padding: 10px;
            font-size: 16px;
            border: solid 1px #535353;
            border-radius: 4px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: 'Eurostile-Bold';
            position: relative;
            z-index: 1;
          }
          .arrow {
            width: 10px;
            height: 10px;
            border: solid white;
            border-width: 0 2px 2px 0;
            display: inline-block;
            padding: 3px;
            transition: transform 0.3s ease;
          }
          .arrow.down {
            transform: rotate(45deg);
          }
          .arrow.up {
            transform: rotate(225deg);
          }
          .options {
            position: absolute;
            top: 90%;
            left: 0;
            width: 100%;
            background-color: #424242;
            border-radius: 0 0 4px 4px;
            z-index: 0;
            overflow: hidden;
            max-height: 0;
            transition:
              max-height 0.5s ease,
              opacity 0.5s ease;
          }
          .options.show {
            max-height: 152px;
          }
          .option-tab {
            padding: 10px;
            color: #fff;
            border-top: none;
            border-radius: 4px;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            border: solid 1px #535353;
            border-top: none;
            cursor: pointer;
            font-size: 16px;
            font-family: 'Eurostile-Bold';
          }
          .option-tab:hover {
            background-color: #555;
          }
          .option-tab.active {
            background-color: #444;
          }
          .contact-us-tab {
            margin-right: 30px;
            padding: 12px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 28px;
            line-height: 31px;
            text-align: center;
            color: #f6f6f6;
            background-color: #a41c1c;
            border-radius: 4px;
            cursor: pointer;
          }
          .intro {
            background-color: #101010;
            position: relative;
            z-index: 2;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .intro-wrapper {
            max-width: 1440px;
          }
          .intro_description {
            padding: 20px 10%;
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            line-height: 32px;
            text-align: center;
          }
          .features {
            display: flex;
            flex-direction: column;
            gap: 52px;
            align-items: center;
            padding-bottom: 70px;
            position: relative;
            z-index: 2;
          }
          .features_title {
            padding-top: 70px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 50px;
            text-align: center;
          }
          .features_container {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 70px;
            margin: 0 auto;
            padding: 20px;
          }
          .active_feature {
            position: relative;
            width: 1272px;
            height: 522px;
            background-color: #101010;
            border-radius: 4px;
          }
          .active_feature::before {
            content: '';
            position: absolute;
            border-radius: 4px;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              to right,
              rgba(16, 16, 16, 1) 0%,
              rgba(16, 16, 16, 1) 35%,
              rgba(16, 16, 16, 0.2) 70%,
              rgba(16, 16, 16, 0) 100%
            );
            z-index: 0;
            pointer-events: none;
          }
          .closeButton {
            position: absolute;
            width: 30px;
            height: 30px;
            top: -12px;
            right: -15px;
            border: none;
            font-size: 24px;
            color: #fff;
            cursor: pointer;
            background-color: #5a5a5a;
            border-radius: 100%;
          }
          .active_feature_title {
            z-index: 1;
            margin-top: 23px;
            margin-left: 51px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 32px;
            position: relative;
            z-index: 2;
          }
          .active_feature_description {
            width: 669px;
            margin-top: 51px;
            margin-left: 51px;
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-weight: 300;
            font-size: 26px;
            position: relative;
            z-index: 2;
          }
          .feature {
            position: relative;
            overflow: hidden;
            min-width: 348px;
            min-height: 220px;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            cursor: pointer;
          }
          .feature::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: inherit;
            background-size: cover;
            background-position: center;
            z-index: 0;
            transition: transform 0.3s ease;
          }
          .feature_title1 {
            position: relative;
            z-index: 1;
            margin-top: 23px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 32px;
            text-align: center;
          }
          .feature:hover::before {
            transform: scale(1.2);
          }
          .models-container {
            background-color: #101010;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 2;
          }
          .models-title {
            padding-top: 21px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 48px;
            text-align: center;
          }
          .product-list {
            width: 100%;
            padding: 30px 0;
            position: relative;
            z-index: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .select-servers_group {
            width: 100%;
            height: 40px;
            background-color: #333;
            color: #fff;
            padding: 10px;
            font-size: 16px;
            border: solid 1px #535353;
            border-radius: 4px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: 'Eurostile-Bold';
            position: relative;
            z-index: 3;
          }
          .servers_groups {
            position: absolute;
            top: 90%;
            left: 0;
            width: 100%;
            background-color: #424242;
            border-radius: 0 0 4px 4px;
            z-index: 2;
            overflow: hidden;
            max-height: 0;
            transition:
              max-height 0.5s ease,
              opacity 0.5s ease;
          }
          .servers_groups.show {
            max-height: 83px;
          }
          .group_options {
            padding: 10px;
            color: #fff;
            border-top: none;
            border-radius: 4px;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            border: solid 1px #535353;
            border-top: none;
            cursor: pointer;
            font-size: 16px;
            font-family: 'Eurostile-Bold';
          }
          .option-tab:hover {
            background-color: #555;
          }
          .option-tab.active {
            background-color: #444;
          }
          .specification-title {
            padding-top: 21px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 50px;
            text-align: center;
          }
          .specification-container {
            background-color: #1b1b1b;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .specification {
            margin-top: 40px;
            margin-bottom: 160px;
            display: flex;
            flex-direction: column;
            width: 1287px;
            height: 813px;
          }
          .specification-row {
            display: flex;
          }
          .specification-name {
            display: flex;
            align-items: center;
            justify-content: center;
            border: solid 1px #ffffff;
            border-right: none;
            width: 200px;
            height: 100px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 24px;
            text-align: center;
          }
          .specification-value {
            padding-left: 15px;
            display: flex;
            align-items: center;
            border: solid 1px #ffffff;
            width: 100%;
            height: 100px;
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 20px;
          }
          .servers_groups_wrapper_mobile {
            display: none;
          }
          .servers_groups_wrapper {
            display: flex;
            padding: 10px 40px;
            margin-top: 20px;
            background-color: #2b2b2b;
            border-radius: 10px;
          }
          .servers_group {
            padding: 0 40px;
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-style: normal;
            font-weight: 400;
            font-size: 28px;
            line-height: 24px;
            text-align: center;
            cursor: pointer;
            border-bottom: solid 1px #d9d9d9;
          }
          .active_group {
            border-bottom: solid 2px #a41c1c;
          }
          .benefits {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 2;
          }
          .benefits-wrapper {
            max-width: 1440px;
          }
          .benefits_options {
            margin-top: 120px;
            margin-bottom: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .benefit {
            width: 320px;
            height: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: start;
          }
          .benefit_image {
            width: 190px;
            height: 190px;
          }
          .benefit_title {
            margin-top: 26px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 26px;
            text-align: center;
          }
          .benefit_subtitle {
            padding: 20px 10%;
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-style: normal;
            font-weight: 400;
            font-size: 24px;
            text-align: center;
          }
          .two_columns_tab {
            background-color: #101010;
          }
          .two-column-section {
            background-color: ${
              twoColumns.background_colour
                ? twoColumns.background_colour
                : '#101010'
            };
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .two-column-wrapper {
            max-width: 1440px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 30px 100px;
            gap: 27px;
          }
          .two-column-title {
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 50px;
            margin-bottom: 30px;
          }
          .two-column-subtitle {
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            line-height: 32px;
          }
          .two-column-image {
            width: 677px;
            height: 629px;
          }
          .partners_title {
            padding-top: 33px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 50px;
            text-align: center;
          }
          .partners_subtitle {
            margin: 15px 0 53px;
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            line-height: 32px;
            text-align: center;
          }
          .partners-images-wrapper {
            overflow: hidden;
            width: 100%;
            position: relative;
            padding-bottom: 100px;
          }
          .partners-images-container {
            display: flex;
            align-items: center;
            gap: 90px;
            width: calc(270px * 6 + 90px * 6);
            animation: scroll 10s linear infinite;
          }
          .partner-image {
            max-width: 270px;
            object-fit: contain;
            flex-shrink: 0;
          }
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-100%);
            }
          }
          .contact-us-section {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .contact-wrapper {
            width: 746px;
            height: 254px;
            border-radius: 28px;
            background: rgba(0, 0, 0, 0.84);
            margin-top: 97px;
            margin-bottom: 114px;
          }
          .contact-title {
            padding-top: 33px;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 50px;
            text-align: center;
          }
          .contact-subtitle {
            font-family: 'EurostileExtended';
            letter-spacing: 1px;
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            line-height: 32px;
            text-align: center;
          }
          .contact-button {
            margin: 42px 39% 30px;
            padding: 12px 0;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 28px;
            line-height: 31px;
            text-align: center;
            color: #f6f6f6;
            background-color: #a41c1c;
            border-radius: 4px;
            cursor: pointer;
          }
          @media (max-width: 1300px) {
            .features_container {
              display: grid;
              grid-template-columns: repeat(2, 3fr);
              gap: 70px;
              margin: 0 auto;
              padding: 20px;
            }
            .active_feature {
              position: relative;
              width: 900px;
              height: 522px;
              background-color: #101010;
              border-radius: 4px;
            }
            .active_feature::before {
              background: linear-gradient(
                to right,
                rgba(16, 16, 16, 1) 5%,
                rgba(16, 16, 16, 0.2) 70%,
                rgba(16, 16, 16, 0) 100%
              );
            }
            .specification {
              width: 990px;
            }
          }
          @media (max-width: ${breakPoints.medium}) {
            .banner {
              background-size: cover;
              height: 420px;
            }
            .banner::before {
              background: linear-gradient(
                to right,
                rgba(0, 0, 0, 1) 0%,
                rgba(0, 0, 0, 0.7) 40%,
                rgba(0, 0, 0, 0.1) 90%,
                rgba(0, 0, 0, 0) 100%
              );
            }
            .banner_title {
              font-size: 32px;
              line-height: 32px;
            }
            .banner_subtitle {
              font-size: 20px;
              line-height: 20px;
            }
            .banner-wrapper {
              background-size: cover;
            }
            .tabs {
              display: none;
            }
            .tabs-mobile {
              display: block;
            }
            .contact-us-tab {
              margin-right: 15px;
              font-size: 20px;
              line-height: 20px;
            }
            .tab_container {
              background-color: #1f1f1f;
              top: 48px;
              padding: 15px 0;
            }
            .product-list {
              display: inline;
            }
            .intro_description {
              font-size: 20px;
              line-height: 20px;
            }
            .features_title {
              font-size: 32px;
              line-height: 32px;
            }
            .features_container {
              width: 100%;
              display: grid;
              grid-template-columns: repeat(6, 1fr);
              overflow-x: scroll;
              gap: 48px;
              margin: 0 auto;
              padding: 10px 10px;
            }
            .features_container::-webkit-scrollbar {
              display: none;ome, Safari, Opera */
            }
            .models-title {
              font-size: 32px;
              line-height: 32px;
            }
            .active_feature {
              position: relative;
              width: 348px;
              background-color: #101010;
              border-radius: 4px;
            }
            .active_feature::before {
              background: linear-gradient(
                to bottom,
                rgba(16, 16, 16, 1) 0%,
                rgba(16, 16, 16, 1) 58%,
                rgba(16, 16, 16, 0.2) 65%,
                rgba(16, 16, 16, 0) 100%
              );
            }
            .active_feature_title {
              margin: 12px;
              font-size: 24px;
              line-height: 24px;
              text-align: center;
            }
            .active_feature_description {
              padding: 26px;
              padding-top: 0;
              margin: 0;
              margin-top: 25px;
              font-size: 16px;
              line-height: 16px;
              text-align: center;
              width: 348px;
            }
            .servers_groups_wrapper {
              display: none;
            }
            .servers_groups_mobile {
              display: block;
              margin-top: 16px;
            }
            .features_title {
              font-size: 32px;
              line-height: 32px;
            }
            .benefits_options {
              padding: 0;
              padding: 0;
              gap: 20px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
            .benefit {
              width: 320px;
              height: 400px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: start;
            }
            .benefit_subtitle {
              font-size: 16px;
            }
            .two-column-wrapper {
              padding: 20px 10px 50px;
              flex-direction: column;
              max-width: 394xp;
              gap: 30px;
            }
            .two-column-title {
              font-size: 32px;
              line-height: 32px;
              text-align: center;
            }
            .two-column-subtitle {
              font-size: 20px;
              line-height: 20px;
              text-align: center;
              padding: 0 40px 20px;

            }
            .two-column-image {
              width: 392px;
              height: 364px;
            }
            .partners_title {
              font-size: 32px;
            }
            .partners_subtitle {
              font-size: 20px;
              line-height: 20px;
              padding: 0 40px;
            }
            .specification-title {
              font-size: 32px;
              line-height: 32px;
            }
            .specification-row {
              justify-content: center;
              align-items: center;
            }
            .specification-name {
              width: 146px;
              font-size: 16px;
            }
            .specification-value {
              width: 230px;
              font-size: 12px;
              line-height: 12px;
            }
            .specification {
              width: 100%;
            }
            .contact-wrapper {
              display: flex;
              flex-direction: column;
              width: 342px;
              height: 182px;
              justify-content: center;
              align-items: center;
            }
            .contact-title {
              padding: 0;
              font-size: 32px;
              line-height: 32px;
            }
            .contact-subtitle {
              padding: 11px 10px;
              font-size: 16px;
              line-height: 16px;
            }
            .contact-button {
              width: 137px;
              margin: 0;
              margin-top: 24px;
              padding: 4px 10px;
              font-size: 20px;
              line-height: 30px;
            }
          }
        `}
      </style>
    </>
  ) : (
    <div>Data not found</div>
  );
}

export async function getStaticProps({ preview = false, previewData }) {
  const { ref } = previewData || {};
  const global = {};

  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          global[id] = body.data;
        }
      });
    })
    .catch(() => null);

  try {
    const content = await Prismic.getByUID(
      'serverslp',
      'server-landing-page',
      ref ? { ref } : null,
    );

    const pcModelIds = content?.data?.pc_models?.map(
      (model) => model.pc_model?.uid,
    );

    const newPcModels = await Promise.all(
      pcModelIds.map(async (id) => {
        const document = await getDocumentByUid('pc_model', id);
        return {
          prismic_uid: id,
          seo_title: document?.data?.seo_title,
        };
      }),
    );

    let featureListDOCS = [];

    if (content?.data.pc_models) {
      const featureListIDs = content?.data.pc_models
        .map((item) => item?.features?.id)
        .filter((item, i, ar) => ar.indexOf(item) === i && item);

      featureListDOCS = await Prismic.getByIDs(
        featureListIDs,
        ref ? { ref } : null,
      ).then((res) => res?.results || []);
    }

    const pcModels = await API.getPcModelBySlugs(pcModelIds); // REDIS

    const modelsData = await Promise.all(
      pcModelIds.map((uid) => getDocumentByUid('pc_model', uid, ref)), // NO REDIS
    );

    const updatedPcModels = pcModels.map((pcModel) => {
      const prismicModel = newPcModels.find(
        (newPcModel) => newPcModel.prismic_uid === pcModel.prismic_uid,
      );
      if (prismicModel) {
        pcModel.seo_title = prismicModel.seo_title;
      }
      return pcModel;
    });

    if (!content) {
      return { notFound: true };
    }

    const results = {};

    return {
      props: {
        global,
        content: content?.data || null,
        preview,
        featureListDOCS,
        pcModels: updatedPcModels.sort((a, b) => a?.price - b?.price),
        modelsData,
      },
      revalidate: 3600,
    };
  } catch (error) {
    console.error('Error fetching content from Prismic', error);
    return { notFound: true };
  }
}

export default ServerLandingPage;
